import React from 'react';
import { TouchableOpacity, View, Text } from 'react-native';
import type { SvgProps } from 'react-native-svg';
import ChevronRightSVG from '~/assets/svgs/chevron-right.svg';
import colors from '~/assets/themes/colors';

interface Props {
  label: string;
  icon: React.FC<SvgProps>;
  onPress: () => void;
  showBadge?: boolean;
  hasBorderTop?: boolean;
  disabled?: boolean;
}

const MenuButton: React.FC<Props> = ({
  icon: Icon,
  label,
  onPress,
  disabled,
  hasBorderTop,
}) => {
  return (
    <TouchableOpacity
      className={`flex w-full items-center flex-row p-4 justify-between ${
        hasBorderTop && 'border-t-[1px]'
      }`}
      onPress={onPress}
      disabled={disabled}
    >
      <View className="flex-row items-center">
        <Icon />
        <Text className="ml-6 text-sm text-light-100">{label}</Text>
      </View>
      <ChevronRightSVG color={colors.light[100]} />
    </TouchableOpacity>
  );
};

export default MenuButton;
